import {
  NoteTargetAreaType,
  NoteTargetName,
  NoteTargetType,
} from '@converge/graphql';
import { Stack, TableCell, TableRow } from '@mui/material';

import { ConvergeNotes } from '../../../notes';
import { useRaterStateContextSelector } from '../data';

export interface IRaterNotesRowProps {
  uuid: string;
  targetName?: NoteTargetName;
  targetType?: NoteTargetType;
  targetArea?: NoteTargetAreaType;
  label?: string[];
  colSpan: number;
  renderAs?: 'row' | 'stack';
  isFullWidth?: boolean;
  openUuid?: string;
}

export const RaterNotesRow = ({
  uuid,
  colSpan,
  targetName,
  targetType,
  targetArea,
  label,
  openUuid,
  renderAs,
  isFullWidth = false,
}: IRaterNotesRowProps) => {
  const expandNotesForUuid = useRaterStateContextSelector(
    ({ expandNotesForUuid }) => {
      return expandNotesForUuid;
    }
  );

  if (
    (expandNotesForUuid !== uuid && !openUuid) ||
    (openUuid && expandNotesForUuid !== openUuid)
  ) {
    return null;
  }

  const notes = (
    <Stack padding={2} flexGrow={1}>
      <ConvergeNotes
        title="Notes"
        hideHeader
        targetName={targetName}
        targetType={targetType}
        targetArea={targetArea}
        targetUuid={uuid}
        label={label}
      />
    </Stack>
  );
  if ((openUuid && expandNotesForUuid === openUuid) || !openUuid) {
    if (renderAs === 'stack') {
      return <>{notes}</>;
    }
  }

  if ((openUuid && expandNotesForUuid === openUuid) || !openUuid) {
    return (
      <TableRow>
        {isFullWidth === false && (
          <TableCell colSpan={colSpan}>{notes}</TableCell>
        )}
        {isFullWidth === true && notes}
      </TableRow>
    );
  }

  return null;
};
